/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { INurse } from 'app/shared/model/nurse.model';
import { IDepartment } from 'app/shared/model/department.model';

export interface INurseDepartment {
  id?: string;
  sortOrder?: number | null;
  skillLevel?: number | null;
  active?: boolean | null;
  cursor?: number | null;
  lastUpdate?: number | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  nurse?: INurse | null;
  department?: IDepartment | null;
}

export const defaultValue: Readonly<INurseDepartment> = {
  active: false,
};
